import { Box, Card, CardContent, Typography } from "@mui/material";

export const ServiceCard = ({ item }: any) => {
  const itemName = item?.name || item?.subServiceName || item?.merchandiseName;
  const itemDescription = item?.description || item?.subServiceDescription || item?.merchandiseDescription;
  const itemPrice = item?.price ? Number(item?.price) : 0;

  return (
    <Card
      sx={{
        borderRadius: 4,
        border: "1px solid #E5E7EB",
        boxShadow: "none",
      }}
    >
      <CardContent>
        <Box display="flex" gap={2}>
          <Typography fontWeight="500 !important" color="#101828" fontSize="14px">{itemName}</Typography>

          <Typography color="#009689" fontWeight="600 !important" fontSize="14px">
            ${itemPrice.toLocaleString()}
          </Typography>
        </Box>

        {itemDescription && (
          <Typography fontSize="13px" color="#6A7282" mt={1} fontWeight="400 !important">
            {itemDescription}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};